
import { defineComponent, computed, defineEmits, ref } from "vue";

export default defineComponent({
    name: "NumberSpinner",
    props: {
        value: {
            type: Number,
            default: 0
        },
        min: {
            default: 0,
            type: Number
        },
        max: {
            default: 50,
            type: Number
        },
        step: {
            default: 1,
            type: Number
        },
        inputClass: {
            default: 'number-spinner__input',
            type: String
        },
        inputName: {
            default: 'input',
            type: String
        },
        inputId: {
            default: 'input',
            type: String
        },
        buttonClass: {
            default: 'number-spinner__button',
            type: String
        },
        disabled: {
            default: false,
            type: Boolean
        },
        required: {
            default: false,
            type: Boolean
        },
        ariaLabelDecrease: {
            default: 'decrease',
            type: String
        },
        ariaLabelIncrease: {
            default: 'increase',
            type: String
        },
        changeId: {
            default: null,
            type: String
        },
    },
    emits: ['changeValue'],
    setup(props, {emit}) {
        const numericValue = ref<number>(props.value);
        const disabledMin = computed(() => numericValue.value <= props.min);
        const disabledMax = computed(() => numericValue.value >= props.max);

        const increase = () => {
            if (numericValue.value < props.max) {
                numericValue.value += props.step;
                emit('changeValue', numericValue.value, props.changeId);
            }
        };

        const decrease = () => {
            if (numericValue.value > props.min) {
                numericValue.value -= props.step;
                emit('changeValue', numericValue.value, props.changeId);
            }
        };

        const inputValue = (event: any) => {
            const value = parseInt(event.target.value);
            if (value >= props.min && value <= props.max) {
                numericValue.value = value;
                emit('changeValue', numericValue.value, props.changeId);
            }
        };

        return {
            numericValue,
            disabledMin,
            disabledMax,
            increase,
            decrease,
            inputValue
        }
    },
});
